import { render, staticRenderFns } from "./AddStudentByClass.vue?vue&type=template&id=59db945a&scoped=true&"
import script from "./AddStudentByClass.vue?vue&type=script&lang=js&"
export * from "./AddStudentByClass.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentByClass.vue?vue&type=style&index=0&id=59db945a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db945a",
  null
  
)

export default component.exports